import Vue from 'vue';
import Vuex from 'vuex';
import { widget } from './widget';
import { query } from './query';
import { preferences } from './preferences';
import { RootState } from '@/store/types';
import { cart } from '@/store/cart';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    locale: 'en-US',
  },
  mutations: {},
  actions: {},
  modules: { widget, query, cart, preferences },
});
